<template>
    <div>
        <date-picker :confirm="false" v-model="time" :type="'date'" :disabled-date="(date) => date < min || date > max" :shortcuts="shortcuts" :clearable="false" :format="'DD-MM-YYYY'" :render-input-text="renderInputText" :range-separator="separator" range></date-picker>
    </div>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

import moment from 'moment'
let context = null

export default {
    props: {
        dateFrom: {
            type: Date,
            required: false,
            default: null
        },
        dateTo: {
            type: Date,
            required: false,
            default: null
        },
        min: {
            type: Date,
            required: false,
            default: null
        },
        max: {
            type: Date,
            required: false,
            default: null
        },
        showTime: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    components: {
        DatePicker
    },
    data() {
        let now = new Date();
        let today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        let yesterday = new Date()
        let weekAgo = new Date()
        weekAgo.setDate(now.getDate() - 7)
        weekAgo = new Date(weekAgo.getFullYear(), weekAgo.getMonth(), weekAgo.getDate(), 0, 0, 0)
        yesterday.setDate(now.getDate() - 1)
        yesterday = new Date(yesterday.getFullYear(), yesterday.getMonth(), yesterday.getDate(), 0, 0, 0)
        return {
            time: null,
			name: '',
			specialName: '',
			separator: '~',
			renderInputText: function(dates) {
            	try {
					if(context.specialName !== ''){
						let s = context.specialName;
						context.specialName = '';
						return s
					}
				} catch(e) {
            		//ignored
				}
				return `${moment(dates[0]).format('DD-MM-YYYY')} ~ ${moment(dates[1]).format('DD-MM-YYYY')}`
			},
            shortcuts: [
                {
                    text: this.$t('Today'),
                    onClick: () => {
                        this.time = [
                            today,
                            now
                        ];
						this.specialName = this.$t('Today')
                    }
                },
                {
                    text: this.$t('Yesterday'),
                    onClick: () => {
                        this.time = [
                            yesterday,
                            new Date(yesterday.getFullYear(), yesterday.getMonth(), yesterday.getDate(), 23, 59, 0)
                        ]
						this.specialName = this.$t('Yesterday')
                    },
                },
                {
                    text: this.$t('Last7Days'),
                    onClick: () => {
                        this.time = [
                            weekAgo,
                            now
                        ]
						this.specialName = this.$t('Last7Days')
                    },
                },
            ]
        };
    },
    watch: {
        async time(newVal) {
        	if(this.specialName === ''){
				newVal[1] = new Date(newVal[1].getFullYear(), newVal[1].getMonth(), newVal[1].getDate(), 23, 59, 0)
        		if(new Date(newVal[1]) > new Date()){
        			newVal[1] = new Date()
				}
			}
            this.$emit('dateChanged', newVal[0], newVal[1]);
        }
    },
    methods: {
        setDate() {
            if(this.dateFrom != null && this.dateTo != null) {
                this.time = [this.dateFrom, this.dateTo]
            }
        },
    },
    mounted: async function() {
		context = this;
        this.setDate()
    }
}
</script>

<style>
.mx-datepicker-range {
	width: 250px;
}
</style>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Datepicker.vue